import {Image} from '@shopify/hydrogen';
import {SocialMediaIcons} from './SocialMediaIcons';
import {socialMediaUrl, sortSocialMediaAccounts} from '../utils/socialMedia';
import PlaceHolderImage from '../assets/images/PlaceholderImage.png';
import {
  PublicPageQueryResultSocialMediaAccount,
  PublicPageQueryResultThemeSettings,
} from '../graphql/queries/LinkpopQuery';
import classNames from 'classnames';

// TODO: Better types for socialMediaAccounts and themeSettings,
// Ideally from GQL codegen.
interface ProfileProps {
  title: string;
  bio?: string;
  profilePictureUrl?: string;
  socialMediaAccounts?: PublicPageQueryResultSocialMediaAccount[];
  themeSettings?: PublicPageQueryResultThemeSettings;
}

export default function Profile({
  title,
  bio = '',
  profilePictureUrl,
  socialMediaAccounts = [],
  themeSettings,
}: ProfileProps) {
  const sortedSocialMediaAccounts =
    sortSocialMediaAccounts(socialMediaAccounts);

  const logoImage = profilePictureUrl
    ? `${profilePictureUrl}?height=192&width=192`
    : PlaceHolderImage;

  return (
    <div
      className={classNames(
        'flex',
        'flex-col',
        'text-center',
        'content-center',
        'items-center',
        'space-y-5',
      )}
    >
      <Image
        className={classNames(
          'inline',
          'h-20',
          'w-20',
          'rounded-full',
          'object-cover',
        )}
        width={96}
        height={96}
        src={logoImage}
        alt={`Linkpop profile picture for ${title}`}
      />

      <h2 className={classNames('text-xl', 'font-medium')}>{title}</h2>
      <p className={classNames('text-md', 'font-light', 'whitespace-pre-wrap')}>
        {bio}
      </p>
      {sortedSocialMediaAccounts.length > 0 && (
        <div className={classNames('flex', 'space-x-2')}>
          {sortedSocialMediaAccounts.map((account) => (
            <a
              className="px-1.5"
              key={account?.network}
              rel="noreferrer noopener nofollow"
              href={socialMediaUrl(account?.network, account?.handle)}
            >
              <SocialMediaIcons
                network={account?.network}
                fillColor={themeSettings?.fontColor}
              />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
